import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { ReleaseNoteService } from '../Services/release-note.service';
import { HeaderService } from '../Services/header.service';
import { ITransferNote } from '../models/release-note.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { EmailService } from '../Services/Email.service';

@Component({
  selector: 'publish-email',
  templateUrl: './publish-email.component.html',
  styleUrls: ['../app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PublishEmailComponent implements OnInit, OnDestroy {

  xferNoteSub: Subscription;
  constructor(private releaseNoteService: ReleaseNoteService,
    protected Sanitizer: DomSanitizer, private formBuilder: FormBuilder, private route: ActivatedRoute,
    private headerService: HeaderService, private emailService: EmailService, private datePipe: DatePipe,
    private router: Router) { }

  noteID: number = +this.route.snapshot.paramMap.get('noteID');
  errorMessage = '';
  xfer: ITransferNote;
  appName: string;
  releaseDate: string;
  version: string;
  emailContent: HTMLElement;

  emailForm: FormGroup;
  get To() { return this.emailForm.get('To'); }
  get Subject() { return this.emailForm.get('Subject'); }

  ngOnInit(): void {
    this.headerService.clearAlerts();
    this.xferNoteSub = this.releaseNoteService.transferNote$.subscribe(
      note => {
        this.xfer = note;
        this.setupContent();
      });

    function validateEmailList(control: FormControl) {
      let formatRegex = /^[\S]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,10}[\S]*;{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,10})[\S]*$/;
      let commaRegex = /^[^,]+$/;

      return (formatRegex.test(control.value) && commaRegex.test(control.value)) ? null : {
        validateEmailList: {
          valid: false
        }
      };
    }

    this.emailForm = this.formBuilder.group({
      To: ['', [Validators.required, validateEmailList]],
      Subject: ['', [Validators.required]],
      Body: new FormControl('')
    });

    this.headerService.setBreadcrumbs(null, null, null, true);
    this.releaseNoteService.pingTransferNote();
  }

  setupContent() {
    if (this.xfer) {
      this.appName = this.xfer.appName;
      this.releaseDate = this.datePipe.transform(new Date(this.xfer.releaseDate), 'EEEE, MMMM dd, YYYY');
      this.version = this.xfer.versionNum;

      this.emailForm.controls['Subject'].setValue(`${this.appName} Production Release Notes`);
    } else {
      this.releaseNoteService.getXFerbyNoteID(this.noteID).subscribe({
        next: response => {
          response.data.releaseDate = new Date(response.data.releaseDate);
          this.releaseNoteService.setTransferNote(response.data);
        },
        error: err => this.errorMessage = err
      });
    }
  }

  isFormValid(): boolean {
    this.headerService.clearAlerts();

    if (this.emailForm.invalid) {
      this.emailForm.markAllAsTouched();
    }

    return !this.emailForm.invalid;
  }

  onSend() {
    this.emailContent = document.getElementById('email-content');
    this.emailForm.get('Body').setValue(this.emailContent.innerHTML);
    if (this.isFormValid()) {
      this.emailService.sendEmail(this.emailForm.value).subscribe(response => {
        if (response.isSuccess) {
          this.pushAlert('success',
            `Email has been sent!`);
          this.returnToEntry();
        } else {
          this.pushAlert('danger',
            `Something went wrong: ${response.message}!`);
        }
      });
    }
  }

  returnToEntry() {
    this.releaseNoteService.setTransferNote(this.xfer);
    this.router.navigate(['noteEntry']);
  }

  cancel() {
    this.returnToEntry();
  }

  pushAlert(typ: string, mes: string) {
    this.headerService.pushAlerts(typ, mes);
    window.scroll(0, 0);
  }

  public ngOnDestroy() {
    if (this.xferNoteSub !== undefined) {
      this.xferNoteSub.unsubscribe();
    }
  }
}

